import React from "react";
import HOC from "./Container";

let numbers_state_employee = 106; // 従業員数
let numbers_state_age = 33; // 平均年齢

let numbers_state_age50 = 6; // 年齢分布：50代
let numbers_state_age40 = 15; // 年齢分布：40代
let numbers_state_age30 = 28; // 年齢分布：30代
let numbers_state_age20 = 51; // 年齢分布：20代

let numbers_state_genderMan = 57; // 男女比：男性
let numbers_state_genderWoman = 43; // 男女比：女性

let numbers_state_typeNew = 62; // 採用比：新卒
let numbers_state_typeMid = 38; // 採用比：中途

let numbers_state_jobDirector = 41; // 職種比：Webディレクター
let numbers_state_jobDesigner = 7; // 職種比：Webデザイナー
let numbers_state_jobEngineer = 29; // 職種比：エンジニア
let numbers_state_jobSales = 7; // 職種比：営業
let numbers_state_jobAccounting = 6; // 職種比：経営企画室
let numbers_state_jobSecretary = 1; // 職種比：社長秘書
let numbers_state_jobSupport = 9; // 職種比：サポートデスク・アルバイト
// let numbers_state_jobVideo = 0; // 職種比：動画クリエイター

// let numbers_state_clothesBusiness = 7;// 服装比：ビジネススーツ
// let numbers_state_clothesOffice =   7;// 服装比：オフィスカジュアル
// let numbers_state_clothesCasual =   86;// 服装比：カジュアル
// let numbers_state_paid =            60;// 有給消化率

let numbers_state_holiday = 123; // 年間休日数
let numbers_state_over = 8.5; // 平均残業時間
let numbers_state_long = 4.08; // 平均勤続年数
// let numbers_state_officer =         36;// 最年少役員
let numbers_state_remoteWork = 3; // リモートワーク
let numbers_state_sitecore = 1; // Sitecore実績
// let numbers_state_growth =          12;// 過去2年間売上成長率

export default class Numbers extends React.PureComponent {
	state = {
		counterNumber: 0,
		ageNumber: 0,
		ageNumber50: 0,
		ageNumber40: 0,
		ageNumber30: 0,
		ageNumber20: 0,
		genderMan: 0,
		genderWoman: 0,
		newGrads: 0,
		midCareer: 0,

		director: 0,
		designer: 0,
		engineer: 0,
		sales: 0,
		accounting: 0,
		secretary: 0,
		supportDesk: 0,

		holidayCounter: 0,
		overCounter: 0,
		remoteWorkCounter: 0,
		longCounter: 0,
		sitecoreNumber: 10,
		income: 0,
	};

	counterNumber = (max, state, callback, delay, isReverse) => {
		let cnt = isReverse ? this.state[state] - 1 : 1;
		let a = {};
		let interval = delay ? delay : 20;
		let counterInterval = setInterval(() => {
			let maxCondition = isReverse ? cnt + 1 : cnt - 1;

			if (maxCondition === max) {
				clearInterval(counterInterval);
				if (callback) callback();
				return;
			}

			a[state] = cnt;
			this.setState(a);
			if (isReverse) cnt--;
			else cnt++;
		}, interval);
	};

	// 社員数
	animateEmployeeNum = () => {
		this.props.sr.reveal(
			"#numbers > .section_contents .numbers_contents .numbers_item.num_member",
			{
				origin: "bottom",
				afterReveal: () => {
					this.counterNumber(numbers_state_employee, "counterNumber");
				},
				duration: 400,
			},
		);
	};

	// 平均年齢
	animateAge = () => {
		let age50 = document.querySelector(
			"#numbers .section_contents .numbers_contents .num_age .item .graph .bar .bar_inner",
		);
		let age40 = document.querySelector(
			"#numbers .section_contents .numbers_contents .num_age .item .graph:nth-child(3) .bar .bar_inner",
		);
		let age30 = document.querySelector(
			"#numbers .section_contents .numbers_contents .num_age .item .graph:nth-child(4) .bar_inner",
		);
		let age20 = document.querySelector(
			"#numbers .section_contents .numbers_contents .num_age .item .graph:nth-child(5) .bar_inner",
		);

		this.props.sr.reveal(
			"#numbers > .section_contents .numbers_contents .numbers_item.num_age",
			{
				origin: "bottom",
				duration: 400,
				afterReveal: () => {
					this.counterNumber(numbers_state_age, "ageNumber");
					this.counterNumber(numbers_state_age50, "ageNumber50");
					this.counterNumber(numbers_state_age40, "ageNumber40");
					this.counterNumber(numbers_state_age30, "ageNumber30");
					this.counterNumber(numbers_state_age20, "ageNumber20");
					setTimeout(
						() => (age50.style.width = numbers_state_age50 + "%"),
						10,
					);
					setTimeout(
						() => (age40.style.width = numbers_state_age40 + "%"),
						300,
					);
					setTimeout(
						() => (age30.style.width = numbers_state_age30 + "%"),
						500,
					);
					setTimeout(
						() => (age20.style.width = numbers_state_age20 + "%"),
						700,
					);
				},
				delay: 1300,
			},
		);
	};

	// 男女比
	animateGender = () => {
		let bar = document.querySelector(
			"#numbers .section_contents .numbers_contents .num_gender .item .bar .bar_inner",
		);

		this.props.sr.reveal(".numbers_item.num_gender", {
			origin: "bottom",
			duration: 400,
			afterReveal: () => {
				this.counterNumber(numbers_state_genderMan, "genderMan");
				this.counterNumber(numbers_state_genderWoman, "genderWoman");
				setTimeout(() => (bar.style.width = "70%"), 500);
				setTimeout(() => (bar.style.width = "30%"), 1000);
				setTimeout(
					() => (bar.style.width = numbers_state_genderMan + "%"),
					1500,
				);
			},
			delay: 300,
		});
	};

	// 採用比
	animateEmployeeType = () => {
		let bar = document.querySelector(
			"#numbers .section_contents .numbers_contents .num_recruit .item .bar .bar_inner",
		);

		this.props.sr.reveal(".numbers_item.num_recruit", {
			origin: "bottom",
			duration: 400,
			afterReveal: () => {
				this.counterNumber(numbers_state_typeNew, "newGrads");
				this.counterNumber(numbers_state_typeMid, "midCareer");
				setTimeout(() => (bar.style.width = "70%"), 200);
				setTimeout(() => (bar.style.width = "20%"), 700);
				setTimeout(
					() => (bar.style.width = numbers_state_typeMid + "%"),
					1200,
				);
			},
			delay: 2000,
		});
	};

	// 職種比
	animateJobType = () => {
		let directorBar = document.querySelector(".bar_director .bar_inner");
		let designerBar = document.querySelector(".bar_designer .bar_inner");
		let engineerBar = document.querySelector(".bar_engineer .bar_inner");
		let salesBar = document.querySelector(".bar_sales .bar_inner");
		let accountingBar = document.querySelector(".bar_planner .bar_inner");
		let secretaryBar = document.querySelector(".bar_secretary .bar_inner");
		let supportDeskBar = document.querySelector(".bar_support .bar_inner");
		let videoBar = document.querySelector(".bar_video .bar_inner");

		this.props.sr.reveal(".numbers_item.num_job", {
			origin: "bottom",
			duration: 600,
			afterReveal: () => {
				this.counterNumber(numbers_state_jobDirector, "director");
				this.counterNumber(numbers_state_jobDesigner, "designer");
				this.counterNumber(numbers_state_jobEngineer, "engineer");
				this.counterNumber(numbers_state_jobSales, "sales");
				this.counterNumber(numbers_state_jobAccounting, "accounting");
				this.counterNumber(numbers_state_jobSecretary, "secretary");
				this.counterNumber(numbers_state_jobSupport, "supportDesk");
				// this.counterNumber(numbers_state_jobVideo, "video")
				setTimeout(
					() =>
						(directorBar.style.width =
							numbers_state_jobDirector + "%"),
					300,
				);
				setTimeout(
					() =>
						(designerBar.style.width =
							numbers_state_jobDesigner + "%"),
					400,
				);
				setTimeout(
					() =>
						(engineerBar.style.width =
							numbers_state_jobEngineer + "%"),
					500,
				);
				setTimeout(
					() => (salesBar.style.width = numbers_state_jobSales + "%"),
					600,
				);
				setTimeout(
					() =>
						(accountingBar.style.width =
							numbers_state_jobAccounting + "%"),
					700,
				);
				setTimeout(
					() =>
						(secretaryBar.style.width =
							numbers_state_jobSecretary + "%"),
					800,
				);
				setTimeout(
					() =>
						(supportDeskBar.style.width =
							numbers_state_jobSupport + "%"),
					900,
				);
				// setTimeout(() => videoBar.style.width = numbers_state_jobVideo+'%', 1000)
			},
			delay: 500,
		});
	};

	// 服装比
	// animateClothesType = () => {
	//   let clothesList = document.querySelectorAll('.step_center')
	//   this.props.sr.reveal(
	//     ".numbers_item.num_clothes",
	//     {
	//       origin: "bottom",
	//       duration: 400,
	//       afterReveal: () => {
	//         setTimeout(() => {
	//           this.counterNumber(numbers_state_clothesBusiness, "businessClothes")
	//           this.counterNumber(numbers_state_clothesOffice, "officeCasual")
	//           this.counterNumber(numbers_state_clothesCasual, "casualClothes")
	//         }, 700)
	//         setTimeout(() => clothesList[0].style.height = '60px', 200)
	//         setTimeout(() => clothesList[1].style.height = '60px', 200)
	//         setTimeout(() => clothesList[2].style.height = '150px', 200)
	//       },
	//       delay: 200
	//     }
	//   )
	// }

	// 有給消化率
	// animateDayOffs = () => {
	//   let donutAnimation = () => {
	//     let tau =  2* Math.PI;
	//     let arc = d3.arc()
	//         .innerRadius(100)
	//         .outerRadius(110)
	//         .startAngle(0)

	//     let svg = d3.select('#dayOffPctg')
	//     let width = +svg.attr('width')
	//     let height = +svg.attr('height')
	//     let g = svg.append('g').attr('transform', 'translate('+ ((width / 2)) + ',' + height/2 + ')')

	//     g.append('path')
	//         .datum({ endAngle: tau })
	//         .style('fill', '#ddd')
	//         .attr('d', arc);

	//     let foreground = g.append('path')
	//         .datum({endAngle: 0})
	//         .style('fill', '#47a3ff')
	//         .attr('d', arc);

	//     d3.timeout(function() {
	//         foreground.transition()
	//             .duration(1000)
	//             .attrTween('d', arcTween(numbers_state_paid / 100 * tau));
	//     }, 200);

	//     function arcTween(newAngle) {
	//         return function(d) {
	//             var interpolate = d3.interpolate(d.endAngle, newAngle);
	//             return function(t) {
	//                 d.endAngle = interpolate(t)
	//                 return arc(d)
	//             }
	//         }
	//     }
	//   }

	//   this.props.sr.reveal(
	//     ".numbers_item.num_salaried",
	//     {
	//       origin: "bottom",
	//       delay: 200,
	//       afterReveal: () => {
	//         this.counterNumber(numbers_state_paid, "dayOffPercentage")
	//         donutAnimation()
	//       }
	//     }
	//   )
	// }

	// 年間休日数
	animateHoliday = () => {
		this.props.sr.reveal(".numbers_item.num_holiday", {
			origin: "bottom",
			delay: 800,
			afterReveal: () => {
				this.counterNumber(numbers_state_holiday, "holidayCounter");
			},
		});
	};

	// 平均残業時間
	animateOver = () => {
		this.props.sr.reveal(".numbers_item.num_over", {
			origin: "bottom",
			delay: 900,
			afterReveal: () => {
				this.counterNumber(numbers_state_over, "overCounter");
			},
		});
	};

	// 最年少役員
	// animateOfficer = () => {
	//   this.props.sr.reveal(
	//     ".numbers_item.num_officer",
	//     {
	//       origin: "bottom",
	//       delay: 500,
	//       afterReveal: () => {
	//         this.counterNumber(numbers_state_officer, "officerCounter", null, 50)
	//       }
	//     }
	//   )
	// }

	// リモートワーク
	animateRemoteWork = () => {
		let intervalTimer = 100;

		this.props.sr.reveal(".numbers_item.num_remoteWork", {
			origin: "bottom",
			delay: 1000,
			afterReveal: () => {
				this.counterNumber(
					numbers_state_remoteWork,
					"remoteWorkCounter",
					null,
					intervalTimer,
				);
			},
		});
	};

	// 平均勤続年数
	animateLong = () => {
		this.props.sr.reveal(".numbers_item.num_long", {
			origin: "bottom",
			delay: 1100,
		});
	};

	// Sitecore実績
	animateSitecore = () => {
		this.props.sr.reveal(".numbers_item.num_sitecore", {
			origin: "bottom",
			delay: 1200,
			afterReveal: () => {
				this.counterNumber(
					numbers_state_sitecore,
					"sitecoreNumber",
					null,
					100,
					true,
				);
			},
		});
	};

	// 売上成長率
	animateIncome = () => {
		this.props.sr.reveal(".numbers_item.num_growth", {
			origin: "bottom",
			delay: 1300,
		});
	};

	componentDidMount() {
		this.animateEmployeeNum();
		this.animateAge();
		this.animateGender();
		this.animateEmployeeType();
		this.animateJobType();
		// this.animateClothesType()
		// this.animateDayOffs()
		this.animateHoliday();
		this.animateOver();
		// this.animateOfficer()
		this.animateRemoteWork();
		this.animateLong();
		this.animateSitecore();
		this.animateIncome();
	}

	render() {
		const {
			counterNumber,
			ageNumber,
			ageNumber20,
			ageNumber30,
			ageNumber40,
			ageNumber50,
			genderMan,
			genderWoman,
			newGrads,
			midCareer,
			director,
			designer,
			engineer,
			sales,
			accounting,
			secretary,
			supportDesk,
			video,
			// businessClothes,
			// officeCasual,
			// casualClothes,
			// dayOffPercentage,
			// refreshCounter,
			// childCounter,
			// officerCounter,
			holidayCounter,
			overCounter,
			remoteWorkCounter,
			longCounter,
			sitecoreNumber,
			income,
		} = this.state;

		return HOC({
			counterNumber,
			ageNumber,
			ageNumber20,
			ageNumber30,
			ageNumber40,
			ageNumber50,
			genderMan,
			genderWoman,
			newGrads,
			midCareer,
			director,
			designer,
			engineer,
			sales,
			accounting,
			secretary,
			supportDesk,
			video,
			// businessClothes,
			// officeCasual,
			// casualClothes,
			// dayOffPercentage,
			// refreshCounter,
			// childCounter,
			// officerCounter,
			holidayCounter,
			overCounter,
			remoteWorkCounter,
			longCounter,
			sitecoreNumber,
			income,
		});
	}
}



// WEBPACK FOOTER //
// ./src/Home/Numbers/index.js